namespace $ { $mol_style_attach( "mol/paginator/paginator.view.css",
 "[mol_paginator] {\n\talign-items: flex-start;\n}\n\n[mol_paginator_value] {\n\tpadding: .5rem 0;\n}\n"
) }